import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

const BreakWordSpan = styled.span`
    word-break: break-word;
`;

const SanitizedHTML = (props) =>
    props &&
    props.innerHtml && (
        <BreakWordSpan
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.innerHtml, {
                    ALLOWED_TAGS: ['p', 'strong', 'em', 'u', 'a', 'br'],
                    ALLOWED_ATTR: ['href', 'target', 'style'],
                }),
            }}
        />
    );

SanitizedHTML.propTypes = {
    innerHtml: PropTypes.string,
};

SanitizedHTML.defaultProps = {
    innerHtml: '',
};

export default SanitizedHTML;
